
<div class="operation_history" *ngIf="updatedBy && updatedAt">
    <fa-icon icon="user"></fa-icon>
    <span class="history-user">{{ updatedBy | user }}</span>
    <fa-icon icon="clock"></fa-icon>
    <span class="history-updated">{{ updatedAt | date:"yyyy/MM/dd HH:mm:ss"}}</span>
</div>